import { createContext } from 'react';

import type { BrowserQueryCache } from './query-cache';

export const BrowserQueryCacheContext = createContext<BrowserQueryCache | null>(null);
